import { useState, useEffect } from "react";
import {
  Autocomplete,
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseManageComments } from "./UseManageComments";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function CommentsManagement(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { operatorsList, DefaultOperator, ChangeOperator } =
    UseManageComments();
  const [operatorChange, setOperatorChange] = useState({
    oldUserID: undefined,
    newUserID: undefined,
  });
  const [operatorDefault, setDefaultOperator] = useState();
  const [operatorsRes, setOperatorsRes] = useState();
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    setProgress(true);
    operatorsList((operators) => {
      const uniqueOperators = Array.from(
        new Map((operators || []).map((item) => [item.userID, item])).values()
      );
      setOperatorsRes(uniqueOperators);
    });
  }, []);

  useEffect(() => {
    if (operatorsRes) {
      setDefaultOperator(operatorsRes.find((m) => m.isMaster == true)?.userID);
    }
  }, [operatorsRes]);

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {operatorsRes && (
          <Autocomplete
            size="small"
            value={
              operatorDefault && operatorDefault
                ? operatorDefault
                : operatorsRes.find((m) => m.isMaster == true)
                ? operatorsRes.find((m) => m.isMaster == true)?.userID
                : ""
            }
            onChange={(event, newValue) => {
              setDefaultOperator(newValue);
            }}
            isOptionEqualToValue={(option, value) => {
              return value == "" || option === value;
            }}
            getOptionLabel={(option) => {
              if (option && operatorsRes) {
                return (
                  operatorsRes &&
                  operatorsRes.find((m) => m.userID == option)?.operator
                );
              }
              return "";
            }}
            sx={{ width: isSmall ? "70%" : "25%", mr: 3 }}
            options={operatorsRes ? operatorsRes?.map((m) => m.userID) : []}
            renderInput={(params) => (
              <TextField
                variant="outlined"
                {...params}
                label="اپراتور پیش فرض"
              />
            )}
          />
        )}
        <Button
          variant="contained"
          onClick={() => {
            DefaultOperator(operatorDefault, () => {
              operatorsList((comments) => {
                setOperatorsRes(comments);
              });
            });
          }}
        >
          ثبت
        </Button>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: isSmall ? "column" : "row",
          alignItems: isSmall ? "flex-start" : "center",
          my: 3,
        }}
      >
        <Typography variant="subtitle2">انتقال از: </Typography>
        {operatorsRes && (
          <Autocomplete
            size="small"
            onChange={(event, newValue) => {
              setOperatorChange({ ...operatorChange, oldUserID: newValue });
            }}
            isOptionEqualToValue={(option, value) => {
              return value == "" || option === value;
            }}
            getOptionLabel={(option) => {
              if (option && operatorsRes) {
                return (
                  operatorsRes &&
                  operatorsRes.find((m) => m.userID == option)?.operator
                );
              }
              return "";
            }}
            sx={{ width: isSmall ? "70%" : "20%", mx: 3 }}
            options={operatorsRes ? operatorsRes?.map((m) => m.userID) : []}
            renderInput={(params) => (
              <TextField variant="outlined" {...params} label="اپراتور" />
            )}
          />
        )}
        <Typography variant="subtitle2"> به </Typography>
        {operatorsRes && (
          <Autocomplete
            size="small"
            onChange={(event, newValue) => {
              setOperatorChange({ ...operatorChange, newUserID: newValue });
            }}
            isOptionEqualToValue={(option, value) => {
              return value == "" || option === value;
            }}
            getOptionLabel={(option) => {
              if (option && operatorsRes) {
                return (
                  operatorsRes &&
                  operatorsRes.find((m) => m.userID == option)?.operator
                );
              }
              return "";
            }}
            sx={{ width: isSmall ? "70%" : "20%", mx: 3 }}
            options={operatorsRes ? operatorsRes?.map((m) => m.userID) : []}
            renderInput={(params) => (
              <TextField variant="outlined" {...params} label="اپراتور" />
            )}
          />
        )}
        <Button
          sx={{ mx: isSmall ? "auto" : 0, mt: isSmall ? 2 : 0 }}
          variant="contained"
          onClick={() => {
            ChangeOperator(operatorChange, () => props.callBack());
          }}
        >
          ثبت
        </Button>
      </Box>
    </Box>
  );
}
